import axiosInstance from '@/utils/axios';
import { API_BASE_URL } from '@/config/api.config';
import type { Course } from '@/types';

const API_URL = API_BASE_URL;

// Re-export Course type for backward compatibility
export type { Course };

export interface CourseFilters {
  exam_id?: string;
  status?: string;
  search?: string;
}

class CoursesService {
  /**
   * Get all courses with optional filters
   */
  async getCourses(filters?: CourseFilters): Promise<Course[]> {
    const params = new URLSearchParams();
    if (filters?.exam_id) params.append('exam_id', filters.exam_id);
    if (filters?.status) params.append('status', filters.status);
    if (filters?.search) params.append('search', filters.search);

    const response = await axiosInstance.get(`${API_URL}/courses?${params.toString()}`);
    return response.data.data || [];
  }

  /**
   * Get course by ID
   */
  async getCourseById(courseId: string): Promise<Course | null> {
    const response = await axiosInstance.get(`${API_URL}/courses/${courseId}`);
    return response.data.data;
  }

  /**
   * Create new course
   */
  async createCourse(courseData: Partial<Course>): Promise<Course> {
    const response = await axiosInstance.post(`${API_URL}/courses`, courseData);
    return response.data.data;
  }

  /**
   * Update course
   */
  async updateCourse(courseId: string, courseData: Partial<Course>): Promise<Course> {
    const response = await axiosInstance.put(`${API_URL}/courses/${courseId}`, courseData);
    return response.data.data;
  }

  /**
   * Delete course
   */
  async deleteCourse(courseId: string): Promise<void> {
    await axiosInstance.delete(`${API_URL}/courses/${courseId}`);
  }
}

export const coursesService = new CoursesService();
